export const objectToArray = (key: string, data: any) => {
  let tempArray: Array<object> = [];
  Object.keys(data).forEach((e: string) => {
    tempArray.push({ ...data[e], [key]: e });
  });
  return tempArray;
};
